import React from 'react';
import classNames from 'classnames/bind';
import Text from '../../../../../atoms/Text';
import ActionButton from '../ActionButton';
import UpcomingEvent from '../../mobile/UpcomingEvent';
import DesktopUpcomingEvent from '../../desktop/UpcomingEvent';
import styles from './index.pcss';

const cx = classNames.bind(styles);

interface UpcomingEventWrapperProps {
  title: string;
  btnLabel: string;
  variant: string;
  data: Record<string, unknown>;
  onClick: (PAGE_TYPE: string) => void;
  platform: string;
}

const UpcomingEventWrapper = (props: UpcomingEventWrapperProps): JSX.Element => {
  const { title = '', btnLabel = '', variant = '', data = [], onClick, platform } = props;
  const isDesktop = platform === 'website';
  const Component = isDesktop ? DesktopUpcomingEvent : UpcomingEvent;
  if (data?.length) {
    return (
      <div className={cx('upcoming-events-wrapper', { padding: !isDesktop })}>
        <div
          className={cx(
            { 'upcoming-events-header': !isDesktop },
            { 'upcoming-events-header-desktop': isDesktop }
          )}
        >
          <div className={cx('title')}>
            <Text variant="T10" color="Nero" weight="bold">
              {title}
            </Text>
          </div>
          <div className={cx('cta', { 'padding-cta': isDesktop })}>
            <ActionButton
              btnLabel={btnLabel}
              variant="small"
              icon="icon-Chevron-Right"
              onClick={onClick}
            />
          </div>
        </div>
        <div className={cx('upcoming-events-list', { 'padding-bottom': isDesktop })}>
          <Component variant={variant} data={data} />
        </div>
      </div>
    );
  }
  return <></>;
};

export default UpcomingEventWrapper;
